import { render } from "./cell-chart.vue?vue&type=template&id=37018498"
import script from "./cell-chart.vue?vue&type=script&lang=js"
export * from "./cell-chart.vue?vue&type=script&lang=js"

import "./cell-chart.vue?vue&type=style&index=0&id=37018498&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__